import { ReactNode } from 'react';
import StepProgress from '../step-progress/StepProgress';

export default function StepWrapper({ children, currentStep }: { children: ReactNode, currentStep: number }) {
    return (
        <div className='bg-white'>
            <div className='wrapper-container'>
                {/* Step  */}
                <div className='sm:px-10 sm:mb-10'>
                    <StepProgress currentStep={currentStep} />
                </div>
            </div>

            <div className='wrapper-container md:pb-[120px] pb-[60px]'>{children}</div>

        </div>
    );
}
